export default "__VITE_ASSET__CVql1ece__"